import React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { grey } from "@mui/material/colors";
import "./style.css";

const CustomSlider = ({ sliderValue, setSliderValue, iniSliderValue }) => {
  const handleChange = (event, newValue) => {
    setSliderValue(newValue);
  };

  // 最大値まで500万円ごとにマークを生成する関数
  const createPriceMarks = (maxValue) => {
    const marks = [];
    // 500万円ごとにマークを追加
    for (let i = 0; i <= maxValue; i += 500) {
      marks.push({
        value: i,
        label: `${i.toLocaleString()}万円`, // ラベルを500万円ごとに設定
      });
    }
    return marks;
  };

  // マークの配列を生成
  const priceMarks = createPriceMarks(iniSliderValue[1]);

  return (
    <Box className='box' sx={{ width: 270 }}>
      <div className='iconTitle'>
        <CreditCardIcon sx={{ color: grey[700] }} />
        <h3 className='sliderTitle'>価格フィルタ</h3>
      </div>

      <Slider
        className='slider'
        color='warning'
        getAriaLabel={() => "Price range"}
        value={sliderValue}
        onChange={handleChange}
        valueLabelDisplay='on'
        getAriaValueText={(value) => `${value.toLocaleString()}万円`}
        min={iniSliderValue[0]}
        max={iniSliderValue[1]}
        step={100}
        marks={priceMarks}
        style={{ width: 200, margin: 30 }} // スタイルの調整
      />
    </Box>
  );
};

export default CustomSlider;
